module.exports = __webpack_public_path__ + "static/media/Twitter.c4eca2ad.svg";